module.exports = __webpack_public_path__ + "static/media/fi_x-circle.65525494.svg";